import { render, staticRenderFns } from "./classe.vue?vue&type=template&id=449040c6&"
import script from "./classe.vue?vue&type=script&lang=js&"
export * from "./classe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449040c6')) {
      api.createRecord('449040c6', component.options)
    } else {
      api.reload('449040c6', component.options)
    }
    module.hot.accept("./classe.vue?vue&type=template&id=449040c6&", function () {
      api.rerender('449040c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/classe.vue"
export default component.exports